import { render } from "./NotificationContainerCard.vue?vue&type=template&id=0a6372b4"
import script from "./NotificationContainerCard.vue?vue&type=script&lang=js"
export * from "./NotificationContainerCard.vue?vue&type=script&lang=js"

import "./NotificationContainerCard.vue?vue&type=style&index=0&id=0a6372b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__